import { create } from 'zustand';

interface SidebarUnreadStoreState {
    // 받은 피드백 및 요청 - 읽지 않은 피드백, 거절 또는 응답하지 않은 피드백 요청 개수
    unreadFeedbackCount: number;
    // 받은 보고서 - 읽지 않은 보고서 개수
    unreadReportCount: number;

    setUnreadFeedbackCount: (count: number) => void;
    setUnreadReportCount: (count: number) => void;
}

export const useSidebarUnreadStore = create<SidebarUnreadStoreState>(set => ({
    unreadFeedbackCount: 0,
    unreadReportCount: 0,

    setUnreadFeedbackCount: (count: number) => {
        set({ unreadFeedbackCount: count });
    },
    setUnreadReportCount: (count: number) => {
        set({ unreadReportCount: count });
    },
}));
